export const isSpinner = (state) => state.showSpinner;



// WEBPACK FOOTER //
// ./src/store/getters.js